import type { Icon } from '../../../src/lib/types'
export const mdiFormatAlignLeft: Icon = {
  "id": "format-align-left",
  "name": "Format Align Left",
  "path": "M3,3H21V5H3V3M3,7H15V9H3V7M3,11H21V13H3V11M3,15H15V17H3V15M3,19H21V21H3V19Z",
  "as": [],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiFormatAlignLeft